import transport from "./../assets/car.svg"
import hoveryavas from "./../assets/hoveryavas.svg";
import uses from "./../assets/used.svg";
import bed from "./../assets/bed.svg";
import archive from "./../assets/archive.svg"
export const agents = [

 {
    id: 1,
    name: "Transporte",
    image: transport,
    description: "Renta un auto o reserva un shuttle"
},
{
    id: 2,
    name: "Vuelos + Hoteles",
    image: hoveryavas,
    description: "Encuentra las mejores ofertas para tu viaje"
},
{
    id: 3,
    name: "Grupos",
    image: uses,
    description: "Obtén una cotización para grupos de más de 9 personas"
},
{
    id: 4,
    name: "Hoteles",
    image: bed,
    description: "Reserva una habitación en cualquier parte del mundo"
},
{
    id: 5,
    name: "Carga",
    image: archive,
    description: "Contamos con servicios de carga y mensajería"
},

];